import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {


const config = useRuntimeConfig()
const route = useRoute()
const title = computed(() => {
  return route.meta?.title || route.matched[0].meta?.title || ''
})

const user = useUserStore()

useHead({
  title,
  titleTemplate: (t) => (t ? `${t} :: SOSV Studio` : 'SOSV Studio'),
  htmlAttrs: { lang: 'en' },
  link: [{ rel: 'icon', href: '/favicon.ico' }]
})
useSeoMeta({
  viewport: 'width=device-width, initial-scale=1, maximum-scale=1',
  description: 'SOSV Staff Portal'
})

// Load UI store
const ui = useUiStore()

// Load Google Tag Manager
if (config.public.googleTagManagerId) {
  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${config.public.googleTagManagerId}`,
        async: true
      },
      {
        children: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${config.public.googleTagManagerId}');
        `
      }
    ]
  })
}


return (_ctx: any,_cache: any) => {
  const _component_AppBar = _resolveComponent("AppBar")!
  const _component_AppNavigation = _resolveComponent("AppNavigation")!
  const _component_NuxtPage = _resolveComponent("NuxtPage")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "hybrasil",
    class: _normalizeClass({ mobile: _unref(ui).mobile })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (_unref(user).loggedIn && _unref(route).name !== 'login')
            ? (_openBlock(), _createBlock(_component_AppBar, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_container, {
            "max-width": _ctx.$ui.maxWidth,
            class: "d-flex ga-8 pb-0 h-100"
          }, {
            default: _withCtx(() => [
              (_unref(user).loggedIn && _unref(route).name !== 'login')
                ? (_openBlock(), _createBlock(_component_AppNavigation, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_NuxtPage)
            ]),
            _: 1
          }, 8, ["max-width"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})